export enum NdfSubmitRequestType {
    STANDARD,
    PERSONAL_PREVIEW,
    TEAM_PREVIEW,
}
